class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    if (!cartLink) return;

    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

   
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    // Check if parsedState has an error before proceeding
    if (parsedState.status === 422 || parsedState.status) {
      // If there's an error, refresh cart to ensure correct state
      fetch(`${window.routes.cart_url}.js`)
        .then((response) => response.json())
        .then((cartData) => {
          // Use the actual cart data instead of the error response
          this.renderCartContents(cartData);
        })
        .catch((error) => {
          console.error('Error fetching cart data:', error);
        });
      return;
    }

    // Normal rendering path for successful add-to-cart
    this.renderCartContents(parsedState);
  }

  // New method to separate the actual rendering logic
  renderCartContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);

      if (!sectionElement) return;
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  constructor() {
    super();
    
    // Add an error handler for stock limit issues
    this.addEventListener('cart:stocklimit', this.handleStockLimitError.bind(this));
  }
  
  handleStockLimitError(event) {
    // Refresh the cart to ensure it's in sync
    fetch(`${window.routes.cart_url}.js`)
      .then(response => response.json())
      .then(cartData => {
        // Use the cart drawer's renderContents method to update the UI
        const cartDrawer = this.closest('cart-drawer');
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(cartData);
        }
      })
      .catch(error => {
        console.error('Error refreshing cart:', error);
      });
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
  
  // Override the updateQuantity method to handle stock limitations
  updateQuantity(line, quantity, name) {
    // Add this check
    const quantityElement = document.getElementById(`Drawer-quantity-${line}`);
    
    if (quantityElement) {
      const max = parseInt(quantityElement.getAttribute('max') || '9999');
      if (max && quantity > max) {
        // Show error and don't proceed with update
        const lineItemError = document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) {
          const errorText = lineItemError.querySelector('.cart-item__error-text');
          if (errorText) {
            errorText.textContent = `Only ${max} available`;
            lineItemError.classList.remove('hidden');
            
            // Reset the input to max value
            quantityElement.value = max;
            
            // Hide error after a delay
            setTimeout(() => {
              lineItemError.classList.add('hidden');
            }, 3000);
          }
        }
        
        // Dispatch a stock limit error event
        this.dispatchEvent(new CustomEvent('cart:stocklimit', {
          bubbles: true,
          detail: { line, quantity, max }
        }));
        
        return; // Don't proceed with the update
      }
    }
    
    // Original code continues here
    super.updateQuantity(line, quantity, name);
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);